<template>
  <div class="login">
    <div class="contents">
      <div class="login-base">
        <p class="reset-title">重置密码</p>
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item prop="password">
            <el-input
              :type="inputTypePassword ? 'password' : 'text'"
              AUTOCOMPLETE="off"
              v-model="form.password"
              placeholder="输入新密码"
              auto-complete="new-password"
            >
              <i
                slot="prefix"
                class="el-input__icon icon iconfont icon-suo"
              ></i>
              <i
                slot="suffix"
                class="el-input__icon icon iconfont"
                :class="
                  inputTypePassword
                    ? 'icon-yincangbukejian'
                    : 'icon-xianshikejian'
                "
                @click="yinchang()"
              ></i>
            </el-input>
          </el-form-item>

          <el-form-item prop="repassword" class="last-item">
            <el-input
              :type="inputTypePasswordReset ? 'password' : 'text'"
              AUTOCOMPLETE="off"
              v-model="form.repassword"
              placeholder="确认新密码"
              auto-complete="new-password"
            >
              <i
                slot="prefix"
                class="el-input__icon icon iconfont icon-suo"
              ></i>
              <i
                slot="suffix"
                class="el-input__icon icon iconfont"
                :class="
                  inputTypePasswordReset
                    ? 'icon-yincangbukejian'
                    : 'icon-xianshikejian'
                "
                @click="yinchangreset()"
              ></i>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              round
              type="primary"
              @click="onSubmit('form')"
              class="loginbutton"
              >提&nbsp;交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.repassword !== "") {
          this.$refs.form.validateField("repassword");
        }
        callback();
      }
    };
    var revalidatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        password: "",
        repassword: "",
      },
      initTime: 2,
      inputTypePassword: true,
      inputTypePasswordReset: true,
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
          { validator: validatePass, trigger: "blur" },
        ],
        repassword: [
          { required: true, message: "两次密码密码不同", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
          { validator: revalidatePass, trigger: "blur", required: true },
        ],
      },
    };
  },
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案",
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案",
        },
      ],
    };
  },
  methods: {
    leftTime() {
      this.initTime--;
      if (this.initTime == 0) {
        this.$router.push({ name: "login" });
      }
    },
    yinchang() {
      this.inputTypePassword = !this.inputTypePassword;
      return false;
    },
    yinchangreset() {
      this.inputTypePasswordReset = !this.inputTypePasswordReset;
      return false;
    },
    filedCheck(prop) {
      let noSave = false;
      this.$refs.form.validateField(prop, (valid) => {
        if (valid) {
          noSave = true;
        }
      });
      return noSave;
    },

    onSubmit() {
      const validateFieldList = Object.keys(this.rules);
      const noSave = validateFieldList.some((i) => this.filedCheck(i));
      if (!noSave) {
        // 调用保存接口
        this.dataFormSubmit();
      }
    },

    dataFormSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          var postdata = {};
          postdata.code = this.$route.params.code;
          postdata.newpassword = this.form.password;
          postdata.newpassword2 = this.form.repassword;
          this.$api.user.resetPassword(postdata).then((res) => {
            if (res.data.errno == 0) {
              this.$FUnitls.showInfo("修改成功", "success");
              setInterval(this.leftTime, 1000);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style  scoped>
.login {
  position: relative;
  width: 100%;
  height: 750px;
  background: url("/static/login/loginbj.png") no-repeat center top;
}
.login-base {
  position: absolute;
  right: 0;
  top: 170px;
  width: 380px;
}
.contents {
  margin: 0 auto;
  position: relative;
}
.reset-title {
  font-size: 24px;
  color: #116cd0;
  margin-bottom: 15px;
  font-weight: 700;
}

.login-base >>> input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #c7c6c6 inset !important;
  -webkit-text-fill-color: #ededed !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
}

.login-base >>> .el-input--prefix .el-input__inner {
  color: #d3d7e4;
  font-size: 16px;
  padding-left: 50px;
  border: none;
  border-bottom: 1px solid #e6e6e6;
  height: 54px;
  line-height: 54px;
  border-radius: 0;
}
.login-base >>> .el-form-item.is-error .el-input__inner,
.login-base >>> .el-form-item.is-error .el-input__inner:focus {
  border: none;
  border-bottom: 1px solid #e6e6e6;
}

.login-base >>> .el-input--prefix .iconfont.icon-shouji {
  font-size: 28px;
}
.login-base >>> .el-input-group__append,
.login-base >>> .el-input-group__prepend {
  border: none;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  color: #0464cd;
}
.login-base >>> .el-input__prefix .iconfont.icon-renzhengguanli {
  font-size: 26px;
}
.login-base >>> .el-input__prefix {
  padding-top: 2px;
}
.login-base >>> .el-input__prefix .iconfont {
  color: #0464cd;
  font-size: 20px;
}
.login-base >>> .loginbutton {
  width: 100%;
  font-size: 20px;
}
.login-base >>> .el-checkbox__label {
  color: #fff;
}
.login-base >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
}
.login-base >>> .el-button {
  border-radius: 26px;
  padding: 14px 23px;
}
.last-item {
  margin-bottom: 45px;
}
.icon-yincangbukejian,
.icon-xianshikejian {
  cursor: pointer;
  color: #0464cd;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/reset.vue